<template>
  <div>
    <b-modal
      v-model="showModal"
      ref="modal"
      centered
      size="lg"
      hide-footer
      footer-class="pt-0 border-0"
    >
      <template #modal-header="{ close }">
        <div class="d-flex justify-content-between align-items-center w-100">
          <div class="text-center flex-grow-1 text-r-20">
            Serial Number
            <span class="custom-text"> : {{ product_name }} </span>
          </div>
        </div>
        <button type="button" aria-label="Close" class="close" @click="close">
          ×
        </button>
      </template>
      <div class="bg-white border-red">
        <div>
          ค้นหา Serial Number
          <span class="custom-text"> : {{ product_name }} </span>
        </div>
        <div class="d-flex justify-content-start align-items-center">
          <InputText
            v-model="filter.search"
            textFloat=""
            type="text"
            name="search_serial"
            placeholder="ค้นหา Serial Number"
            faIcon="search"
            className="my-2"
            :disabled="isBusy"
            @onEnter="(val) => handleSearch(val)"
            @onClickIcon="(val) => handleSearch(val)"
          />
          <div>
            <img
              src="@/assets/images/icons/bin.png"
              alt="delete"
              class="pointer delete-icon"
              center
              width="32"
              @click="handleSearch('')"
            />
          </div>
        </div>
        <b-row>
          <b-col>
            <b-table
              v-if="!isMobile"
              responsive
              striped
              hover
              :fields="fields"
              :items="items"
              :busy="isBusy"
              show-empty
              empty-text="No matching records found"
              class="table-main"
              :no-border-collapse="false"
              sticky-header
            >
              <template v-slot:cell(select)="data">
                <b-button
                  variant="outline-primary-color"
                  class="btn-modal btn-hover"
                  @click="unselectRow(data.item.id)"
                  :disabled="isBusy"
                  v-if="select_serial == data.item.serial"
                >
                  ยกเลิก
                </b-button>

                <b-button
                  variant="primary-color"
                  class="btn-modal btn-hover btn-select"
                  @click="selectRow(data.item)"
                  :disabled="
                    isBusy ||
                    productList.find(
                      (x) => x.serial_name === data.item.serial
                    ) !== undefined
                  "
                  v-else
                >
                  เลือก
                </b-button>
              </template>
              <template v-slot:cell(serial_detail)="data">
                {{ data.item.serial_detail || "-" }}
              </template>
              <template v-slot:table-busy>
                <div class="text-center text-black my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-2">Loading...</strong>
                </div>
              </template>
            </b-table>
            <Pagination
              @handleChangeTake="(val) => handleChangeTake(val, 'booth')"
              :pageOptions="pageOptions"
              :filter="filter"
              :rows="rows"
              @pagination="(val) => pagination(val)"
            />
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import OtherLoading from "@/components/loading/OtherLoading";
import InputText from "@/components/inputs/InputText";
// import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination";
export default {
  components: {
    OtherLoading,
    InputText,
    Pagination,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
      isRequired: false,
    },
    branchId: {
      type: Number,
      isRequired: true,
    },
    productList: {
      type: Array,
      isRequired: true,
    },
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      filter: {
        search: "",
        page: 1,
        take: 5,
      },
      fields: [
        {
          key: "select",
          label: "",
        },
        {
          key: "serial",
          label: "Serial",
        },
        {
          key: "serial_detail",
          label: "Detail",
        },
        {
          key: "price",
          label: "Price",
        },
      ],
      select_serial: "",

      now: null,
      items: [],
      isBusy: false,
      rows: 0,
      indexProduct: [],
      selecedHeaderDiscountIdList: [],
      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      product_id: "",
      product_name: "",
    };
  },

  methods: {
    async getSerial() {
      this.isLoading = true;
      this.isBusy = true;
      await this.axios
        .post(
          `${this.$baseUrl}/product/get_product_serial/${this.product_id}/${this.branchId}`,
          this.filter
        )
        .then(async (data) => {
          if (data.result == 1) {
            await this.$store.dispatch("getDynamicFields", {
              products_id: data.detail.data.map((el) => el.product_id),
              body: data.detail.data,
              serials_id: data.detail.data.map((el) => el.id),
              fields: this.fields,
            });
            this.items = data.detail.data;
            this.rows = data.detail.count;

            this.isLoading = false;
          }
        });

      this.isBusy = false;
    },
    async show(product, index) {
      this.indexProduct = index;
      this.filter.page = 1;
      this.product_id = product.product_id;
      this.product_name = product.product_name;
      if (product.serial_name) {
        this.select_serial = product.serial_name;
      } else {
        this.select_serial = null;
      }
      this.showModal = true;
      await this.getSerial();
    },
    hide() {
      this.showModal = false;
    },
    async selectRow(item) {
      this.select_serial = item.serial;
      this.$emit(
        "selectSerial",
        item,
        this.product_id,
        this.indexProduct,
        item.id
      );
    },
    async unselectRow() {
      this.select_serial = "";
      this.$emit("unselectItem", null, this.product_id, this.indexProduct);
    },
    handleSearch(search) {
      if (!this.isBusy) {
        this.filter.page = 1;
        this.filter.search = search;
        this.getSerial();
      }
    },
    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;
      this.getSerial();
    },
    pagination(page) {
      this.filter.page = page;
      this.getSerial();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-header {
  color: #fff;
  width: 100%;
  background-color: var(--primary-color);
}
::v-deep .modal-body {
  padding: 1rem 1rem;
}
.btn-primary .modal-body {
  margin: auto;
  text-align: center;
}
::v-deep .nav-tabs li:nth-child(2) {
  border-left: 1px solid white;
  border-right: 1px solid white;
}

::v-deep .b-table-sticky-header {
  max-height: 310px;
}

.product-card {
  min-height: 88px;
  cursor: pointer;
  color: #333333;
  background-color: #fff;
  padding: 0.5rem;
  margin: 0.5rem;

  .product-card-detail {
    height: 100%;
    display: flex;
    justify-content: space-between;
  }
}

.no-data-item {
  min-height: 88px;
  display: flex;
  justify-content: center;
  font-size: 14px;
  color: #bdbdbd;
  align-items: center;
  background-color: #fff;
  padding: 0.5rem;
  margin: 0.5rem;
}

@media (max-width: 768px) {
  ::v-deep .div-input {
    width: 100%;
  }
  ::v-deep .modal-dialog {
    margin: 0px;
    max-width: 100vw !important;
    .modal-content {
      width: 100vw;
      height: 100vh;
      .modal-body {
        overflow-y: auto;
      }
    }
  }
}

.btn-select:disabled:hover {
  background-color: var(--primary-color) !important;
  color: white !important;
}

.delete-icon {
  margin-left: 8px;
  // margin-bottom: 13px;
}

.custom-text {
  color: white;
}
</style>
